var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyledCloseFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42132",
    "data-name": "Group 42132",
    transform: "translate(20456 18541)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15459",
    "data-name": "Rectangle 15459",
    width: 16,
    height: 16,
    transform: "translate(-20456 -18541)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "letter-x",
    d: "M22.838,18.7a33.278,33.278,0,0,0-3.565-5.553c1.517-1.74,2.894-3.324,3.252-3.772.723-.9.673-1.29-.681-1.3-.971,0-1.306-.122-1.949.552-.377.395-1.19,1.362-2.123,2.541-1.493-1.925-2.876-3.585-3.458-4.2-.831-.871-1.266-.719-2.523-.713-1.752.01-1.818.51-.881,1.679.521.652,2.71,3.166,4.952,5.733a23.986,23.986,0,0,0-2.545,4.007c-.464,1.161.568,1.668,1.445.644.483-.564,1.466-1.69,2.577-2.963,1.557,1.783,2.961,3.391,3.629,4.171,1.135,1.324,2.472.668,1.871-.835Z",
    transform: "translate(-20464.648 -18546.252)",
    fill: "#ed1c24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyledCloseFilled);
export default __webpack_public_path__ + "static/media/styled-close-filled.4aacb10634b7fc7ae0c20edb869aa1a1.svg";
export { ForwardRef as ReactComponent };